import { useTradeMarket } from "../../hooks/use-trade-data.ts";
import { TradePanel } from "../trade-panel.tsx";
import { MarketInfoHeader } from "./market-info-header.tsx";
import { MarketInfoMetrics } from "./market-info-metrics.tsx";
import { useCoinLogo } from "./use-coin-logo.ts";
import { useMarketInfo } from "./use-market-info.tsx";

export function MarketInfo() {
	const { marketData } = useTradeMarket();
	const info = useMarketInfo(marketData);
	const logo = useCoinLogo(marketData.coin, marketData.dex);

	return (
		<TradePanel className="overflow-hidden shadow-none">
			<div className="trade-panel-handle flex h-full items-center justify-between gap-1 border-b border-trade-border-subtle px-4 md:gap-4">
				<MarketInfoHeader
					currentCoin={marketData.coin}
					dex={marketData.dex}
					logo={logo}
					symbolLabel={info.symbolLabel}
					symbolBadgeLabel={info.symbolBadgeLabel}
				/>
				<MarketInfoMetrics metrics={info.metrics} />
			</div>
		</TradePanel>
	);
}
